import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { Field, reduxForm, SubmissionError } from 'redux-form';

import Button from 'components/common/Button';
import UploadField from 'components/fields/UploadField';
import FormError from 'components/common/FormError';
import Link from 'components/common/Link';

import importFileTypes from 'config/importFileTypes';

import {
  importDataPortability,
  requestDownloadDataPortabilityExample,
  requestDownloadDataPortabilityTemplate,
} from 'redux/modules/dataPortability';

const styles = () => ({
  grid: {
    marginTop: 10,
    '&:first-child': {
      marginTop: 0,
    },
  },
  link: {
    display: 'block',
    width: '100%',
    textAlign: 'center',
    '& + $link': {
      marginTop: 8,
    },
  },
  button: {
    display: 'flex',
    margin: '16px auto 0',
  },
});

function onSubmit(values, dispatch, props) {
  if (!values.File) {
    throw new SubmissionError({
      _error: 'No file selected',
    });
  }

  return new Promise((resolve, reject) => {
    dispatch(importDataPortability({
      values: {
        ID: props.route,
        ...values,
      },
      resolve,
      reject,
    }));
  }).then(res => res,
    (err) => {
      if (err.error) {
        throw new SubmissionError({ _error: err.error });
      }
      throw new SubmissionError(err);
    });
}

function onSubmitSuccess(values, dispatch, props) {
  props.reset();
}

function onChange(values, dispatch, props) {
  if (values.File) {
    dispatch(props.clearSubmitErrors());
  }
}

const HCPCSCodeCreateEditForm = ({
  handleSubmit,
  className,
  error,
  submitting,
  submit,
  subtitle,
  route,
  classes,
}) => (
  <form
    className={className}
    noValidate
    onSubmit={handleSubmit}
    autoComplete="off"
  >
    <Grid
      container
      direction="column"
      alignItems="center"
      justify="center"
      spacing={24}
    >
      {(subtitle || error) &&
        <Grid item>
          <Typography
            variant="caption"
            color="secondary"
            align="center"
            gutterBottom
          >
            {subtitle}
          </Typography>
          {error &&
            <FormError className={classes.error}>
              {error}
            </FormError>
          }
        </Grid>
      }
      <Grid item>
        <Field
          id="File"
          name="File"
          component={UploadField}
          variant="import"
          label={(
            <Typography variant="caption" align="center">
              Drag xls, xlsx, csv <br />
              file here
            </Typography>
          )}
          loading={submitting}
          accept={importFileTypes}
          fullWidth
        />
        <Button
          className={classes.button}
          variant="raised"
          color="primary"
          disabled={submitting}
          onClick={submit}
        >
          Upload File
        </Button>
      </Grid>
      <Grid item>
        <Link
          className={classes.link}
          color="primary"
          bold
          size="md"
          onClick={() => requestDownloadDataPortabilityExample(route)}
        >
          Download an example file
        </Link>
        <Link
          className={classes.link}
          color="primary"
          bold
          size="md"
          onClick={() => requestDownloadDataPortabilityTemplate(route)}
        >
          Download a template file
        </Link>
      </Grid>
      <Grid item>
        <Typography
          variant="caption"
          color="secondary"
          align="center"
        >
          Uploaded files must be in a spreadsheet format (i.e. excel)<br />
          Email <Link color="primary" href="mailto:support@dme4dme.com">support@dme4dme.com</Link> if you need any assistance with your uploads.
        </Typography>
      </Grid>
    </Grid>
  </form>
);

HCPCSCodeCreateEditForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  error: PropTypes.string,
  className: PropTypes.string,
  submitting: PropTypes.bool.isRequired,
  subtitle: PropTypes.string,
  route: PropTypes.string,
  classes: PropTypes.shape({
    grid: PropTypes.string.isRequired,
  }).isRequired,
};

HCPCSCodeCreateEditForm.defaultProps = {
  className: '',
  error: null,
  subtitle: null,
  route: null,
};

export default reduxForm({
  form: 'hcpcsCodesUpload',
  onSubmit,
  onSubmitSuccess,
  onChange,
})(withStyles(styles)(HCPCSCodeCreateEditForm));



// WEBPACK FOOTER //
// ./src/components/settings/UploadDialog/UploadDialogForm.js